import React, { useState, useRef, KeyboardEvent } from 'react';
import { SendOutlined } from '@ant-design/icons';
import {
  ChatInput as ChatInput__Root,
  ChatInput__TextArea,
  ChatInput__SendBtn,
  ChatInput__CharCount,
  ChatInput__SendIcon,
} from './ChatInput.styles';

export interface ChatInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
  maxLength?: number;
  placeholder?: string;
}

export const ChatInput: React.FC<ChatInputProps> = ({
  onSend,
  disabled = false,
  maxLength = 2000,
  placeholder = 'Ask the assistant…',
}) => {
  const [message, setMessage] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleSend = () => {
    const trimmedMessage = message.trim();
    if (trimmedMessage && !disabled) {
      onSend(trimmedMessage);
      setMessage('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (value.length <= maxLength) {
      setMessage(value);
    }
  };

  return (
    <ChatInput__Root>
      <ChatInput__TextArea
        ref={textareaRef}
        value={message}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
      />
      {message.length > 0 && (
        <ChatInput__CharCount $warning={message.length > maxLength * 0.9}>
          {message.length}/{maxLength}
        </ChatInput__CharCount>
      )}
      <ChatInput__SendBtn
        onClick={handleSend}
        $disabled={disabled || !message.trim()}
        disabled={disabled || !message.trim()}
        aria-label="Send message"
      >
        <ChatInput__SendIcon><SendOutlined /></ChatInput__SendIcon>
      </ChatInput__SendBtn>
    </ChatInput__Root>
  );
};
